<template>
  <section class="min-h-screen bg-gray-100 pt-16 pb-8 px-4">
    <div class="max-w-7xl mx-auto space-y-10">
      <!-- Heading -->
      <div class="text-center mb-12">
        <h2 class="text-4xl md:text-5xl font-extrabold tracking-tight text-primary mb-4 leading-tight">
          Why Choose TrendzTube
        </h2>
        <p class="mt-4 text-base md:text-lg text-gray-700">
          Discover how our platform helps creators grow their YouTube channels faster
        </p>
      </div>

      <!-- Row 1: AI-Generated Video Ideas -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div>
          <h3 class="text-2xl md:text-3xl font-extrabold text-primary-dark">
            AI-Generated Video Ideas<br class="hidden md:block" /> Based on Real Trends
          </h3>
          <p class="mt-4 text-gray-600 leading-7">
            Get personalized video ideas powered by what's trending right now—each idea includes tags, difficulty, trend growth, and real trending videos that inspired it.
          </p>
        </div>

        <div class="mock-wrap">
          <div class="mock-surface p-5 md:p-6 flex items-center justify-center overflow-hidden">
            <img 
              src="@/assets/screenshot_benefits_1.png" 
              alt="AI-Generated Video Ideas Example"
              class="w-full h-auto rounded-lg shadow-sm"
            />
          </div>
        </div>
      </div>

      <!-- Row 2: Smart Insights -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div class="order-2 md:order-1 mock-wrap">
          <div class="mock-surface p-5 md:p-6 flex items-center justify-center overflow-hidden">
            <img 
              src="@/assets/screenshot_benefits_2.png" 
              alt="Smart Insights Dashboard"
              class="w-full h-auto rounded-lg shadow-sm"
            />
          </div>
        </div>

        <div class="order-1 md:order-2">
          <h3 class="text-2xl md:text-3xl font-extrabold text-primary-dark">
            Smart Insights to Guide<br class="hidden md:block" /> Your Next Video
          </h3>
          <p class="mt-4 text-gray-600 leading-7">
            See what's trending across music, gaming, and movies, find untapped content gaps, discover the best upload times, and understand what your audience is engaging with right now.
          </p>
        </div>
      </div>

      <!-- Row 3: Real-Time Trending Videos -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
        <div>
          <h3 class="text-2xl md:text-3xl font-extrabold text-primary-dark">
            Real-Time<br class="hidden md:block" /> Trending Videos
          </h3>
          <p class="mt-4 text-gray-600 leading-7">
            Explore the latest hits dominating YouTube today. Music, gaming, trailers, and more—updated live with views, creators, and one-click access to every video.
          </p>
        </div>

        <div class="mock-wrap">
          <div class="mock-surface p-5 md:p-6 flex items-center justify-center overflow-hidden">
            <img 
              src="@/assets/screenshot_benefits_3.png" 
              alt="Real-Time Trending Videos"
              class="w-full h-auto rounded-lg shadow-sm"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default { name: "Benefits_" };
</script>

<style scoped>
/* Match HowItWorks.vue styling */
.mock-wrap {
  border-radius: 0.75rem;
  padding: 0.75rem;
  background: linear-gradient(180deg, rgba(239,68,68,0.10), rgba(239,68,68,0.04));
}
.mock-surface {
  position: relative;
  border-radius: 0.75rem;
  background: #fff;
  min-height: 10rem;
  box-shadow: 0 2px 8px 0 rgba(239,68,68,0.06);
}
.mock-surface::before {
  content: "";
  position: absolute;
  inset: 0;
  padding: 2px;
  border-radius: inherit;
  background: linear-gradient(145deg, rgba(239,68,68,0.18), rgba(239,68,68,0.08));
  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
          mask-composite: exclude;
  pointer-events: none;
}

/* Logo chips */
.chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 0.75rem;
  border-radius: 0.75rem;
  background: #ffffff;
  border: 1px solid rgba(239,68,68,0.18);
  box-shadow: 0 2px 6px rgba(239,68,68,0.06);
  font-size: 12px;
  font-weight: 600;
  color: #0f172a; /* slate-900 */
}

/* General styling to match HowItWorks.vue */
.shadow-sm {
  box-shadow: 0 2px 8px 0 rgba(80,36,255,0.06);
}
.rounded-lg {
  border-radius: 0.75rem;
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
</style>
